import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Col, Row } from 'antd';

import * as actions from '../../actions';
import { formatProgress } from '../../util/formatProgress';
import { cleanString, createMarkup } from '../../util/renderHelper';
import { pathSafeString } from '../../util/pathSafeString';
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';
import { ReactComponent as IconChevronLeft } from '../Sprites/icon-chevron-left.svg';

const ProviderDescription = ({ description }) =>
  !!description ? (
    <div
      className="provider-section__description"
      dangerouslySetInnerHTML={createMarkup(cleanString(description))}
    />
  ) : (
    ''
  );

const ProviderLink = ({ linkURL, callToAction, openCurrentProcessInfo }) =>
  !!linkURL && !!callToAction ? (
    <Link
      to={linkURL}
      className="provider-section__cta"
      onClick={() => openCurrentProcessInfo()}
    >
      <span className="provider-section__cta-text">
        {cleanString(callToAction)}
      </span>
      <IconChevronRight className="provider-section__cta-icon" />
    </Link>
  ) : (
    ''
  );

const ProviderSection = ({
  subSection: { name, description, callToAction, slug },
  pathname,
  openCurrentProcessInfo
}) => (
  <article id={pathSafeString(cleanString(name))} className="provider-section">
    <Row>
      <Col xs={{ span: 22, offset: 1 }} lg={{ span: 24, offset: 0 }}>
        <h3 className="provider-section__heading">{cleanString(name)}</h3>
        <ProviderDescription description={description} />
        <ProviderLink
          linkURL={`${pathname}/${slug}`}
          callToAction={callToAction}
          openCurrentProcessInfo={openCurrentProcessInfo}
        />
      </Col>
    </Row>
  </article>
);

const ProviderHeaderMobile = ({ match, name, currentIndex }) => {
  const path =
    match.url.indexOf(`/${match.params.providerSection}`) !== -1
      ? match.url.slice(
          0,
          match.url.indexOf(`/${match.params.providerSection}`)
        )
      : match.url;
  return (
    <div className="provider-overview__mobile">
      <Link className="provider-overview__mobile-controls" to={path}>
        <IconChevronLeft />
        <span>Back</span>
      </Link>
      <div className="provider-overview__mobile-header">
        <div className="provider-overview__mobile-name">
          <span>{name}</span>
        </div>
      </div>
    </div>
  );
};

const ProviderSections = ({
  currentProviderContent,
  isMobile,
  closeCurrentContent,
  match,
  history,
  pathname,
  openCurrentProcessInfo
}) => {
  const displayProviderSection = currentProviderContent.subSections.map(
    subSection => (
      <ProviderSection
        key={`provider-section-${subSection.id}`}
        subSection={subSection}
        pathname={pathname}
        openCurrentProcessInfo={openCurrentProcessInfo}
      />
    )
  );
  return (
    <>
      {isMobile ? (
        <ProviderHeaderMobile
          name={cleanString(currentProviderContent.name)}
          closeCurrentContent={closeCurrentContent}
          currentIndex={currentProviderContent.index}
          match={match}
          history={history}
        />
      ) : (
        ''
      )}
      <div className="provider-overview__sections">
        <h2 className="provider-overview__heading">
          {cleanString(currentProviderContent.name)}
        </h2>
        {displayProviderSection}
      </div>
    </>
  );
};

class ProviderOverview extends Component {
  static displayName = 'ProviderOverview';

  componentDidMount() {
    const { updateProgress } = this.props;
    const componentProgress = formatProgress(this.constructor.displayName, true);
    updateProgress(componentProgress);
  }

  render() {
    const {
      currentProviderContent,
      isMobile,
      closeCurrentContent,
      match,
      history,
      openCurrentProcessInfo
    } = this.props;
    const path =
      match.url.indexOf(`/${match.params.subSection}`) !== -1
        ? match.url.slice(0, match.url.indexOf(`/${match.params.subSection}`))
        : match.url;
    return (
      <ProviderSections
        currentProviderContent={currentProviderContent}
        isMobile={isMobile}
        closeCurrentContent={closeCurrentContent}
        match={match}
        history={history}
        pathname={path}
        openCurrentProcessInfo={openCurrentProcessInfo}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentProviderContent: state.currentProviderContent,
  isMobile: state.app.isMobile,
  progress: state.app.progress,
});

const mapDispatchToProps = dispatch => ({
  openCurrentProcessInfo: () =>
    dispatch(actions.currentProviderActions.openCurrentProcessInfo()),
  updateProgress: progress =>
    dispatch(actions.appActions.updateProgress(progress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProviderOverview));
